import { render } from "./Legales.vue?vue&type=template&id=d102eaec"
import script from "./Legales.vue?vue&type=script&lang=js"
export * from "./Legales.vue?vue&type=script&lang=js"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__